import { ActionType } from '../actionTypes';

export const fetchUserHandler = (payload: any) => {
  return {
    type: ActionType.FETCH_USER,
    payload: payload,
  };
};
